import React, { type FC } from "react";
import { FilterFormBuilder } from "../FilterFormBuilder/FilterFormBuilder";
import { type FilterFormPropsBase } from "../types/props";
import { getPdfsFilters } from "./pdfsFilters";
import { type PdfFiltersEnum } from "../../../features/Library/Pdfs/types/models";

export interface PdfsFilterFormForPacksProps extends FilterFormPropsBase<PdfFiltersEnum> {}

const PdfsFilterFormForPacks: FC<PdfsFilterFormForPacksProps> = ({ filterOptions, filter, updateFilter }) => (
  <FilterFormBuilder
    filterOptions={filterOptions}
    filter={filter}
    updateFilter={updateFilter}
    items={getPdfsFilters(false)}
  />
);

export default PdfsFilterFormForPacks;
